import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SharedModule } from '../../shared/shared.module';
//multiselect
import { VideoCall } from './video-call.component';
import { VideoCallRoutingModule } from './video-call-routing.module';

@NgModule({
  imports: [ 
      CommonModule,
      SharedModule,
      FormsModule,
      ReactiveFormsModule,
      HttpModule,
      VideoCallRoutingModule
  ],
  declarations: [
    //VideoCall
  ],
  providers: [
  ],
  //bootstrap: [VideoCall]
})
export class VideoCallModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/video-call/video-call.module.ts